export default __webpack_public_path__ + "static/media/pooh.7b324c5f.svg";